<template>
  <div class="bottom">
    <p>{{ msg1 }}</p>
    <p>{{ msg2 }} {{msg3}}</p>
    <p>{{msg4}}</p>
  </div>
</template>
<script>
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
export default {
  name: 'bottom',
  data () {
    return {
      channelInfo: {},
      msg1: '',
      msg2: '',
      msg3: '',
      msg4: ''
      // msg3: '浙ICP备17007012号-2'
    }
  },
  created () {
    if (localStorage.getItem('channelInfo') != null) {
      this.channelInfo = JSON.parse(localStorage.getItem('channelInfo'))
      this.setInfo()
    } else {
      this.ChannelFindInfo();
    }
  },
  methods: {
    ChannelFindInfo () {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        localStorage.setItem('channelInfo', JSON.stringify(res.data))
        this.channelInfo = res.data
        this.setInfo()
      })
    },
    setInfo () {
      if (this.channelInfo.channelName) {
        this.msg1 = this.channelInfo.channelName
      }
      if (this.channelInfo.servicePhone) {
        this.msg2 = "客服电话：" + this.channelInfo.servicePhone
      }
      if (this.channelInfo.servicePerson) {
        this.msg3 = "联系人：" + this.channelInfo.servicePerson
      }
      if (this.channelInfo.serviceAddress) {
        this.msg4 = "联系地址：" + this.channelInfo.serviceAddress
      }
    }
  }
}
</script>
<style scoped>
.bottom {
  margin-top: -144px;
  text-align: center;
  padding: 25px;
  width: 100%;
  height: 144px;
  color: #ccc;
  background: rgba(242, 242, 242, 1);
}
.bottom p {
  height: 24px;
  line-height: 24px;
}
</style>
